/* Button crew: one random character per product page load, drawn over the real add-to-cart button. */
(function(){
 const root=document.querySelector('[data-zf-crew]'),cfgEl=document.querySelector('[data-zf-crew-config]');
 if(!root||!cfgEl)return;
 const btn=root.querySelector('.zf-crew__button'),form=btn&&btn.form,text=btn&&btn.querySelector('[data-add-text]');
 if(!form||!text)return;
 let cfg;try{cfg=JSON.parse(cfgEl.textContent)}catch{return}
 const ids=Object.keys(cfg);if(!ids.length)return;
 const H=132,BX=104,BY=76,BH=48,ORANGE='#ef761f',GREEN='#cfe4c5',INK='#202a28';
 const clamp=x=>Math.max(0,Math.min(1,x)),lerp=(a,b,q)=>a+(b-a)*clamp(q),ease=q=>{q=clamp(q);return q*q*(3-2*q)};
 const reg=window.ZFCrew=window.ZFCrew||{mods:{}};reg.reg=(k,mod)=>{reg.mods[k]=mod;if(reg.ready)reg.ready(k)};

 let last='';try{last=sessionStorage.getItem('zf-crew')||''}catch{}
 const pool=ids.filter(k=>k!==last).length?ids.filter(k=>k!==last):ids,fixed=cfgEl.dataset.fixed,id=cfg[fixed]?fixed:pool[Math.floor(Math.random()*pool.length)];
 try{sessionStorage.setItem('zf-crew',id)}catch{}

 const motion=matchMedia('(prefers-reduced-motion: reduce)'),hoverOk=matchMedia('(hover: hover)');
 const cv=document.createElement('canvas'),g=cv.getContext('2d');cv.className='zf-crew__canvas';cv.setAttribute('aria-hidden','true');root.prepend(cv);
 let W=0,m=null,imgs=[],phase='idle',t0=0,resolved=false,hover=false,peek=0,prev=0,raf=0,timer=0;

 function path(x,y,w,h,r){g.beginPath();if(g.roundRect)g.roundRect(x,y,w,h,r);else g.rect(x,y,w,h)}
 function rr(x,y,w,h,r,fill){g.fillStyle=fill;path(x,y,w,h,r);g.fill()}
 /* zone: [left,right] in the current transform that the label must stay inside (keeps text clear of a character). */
 function label(s,cx,cy,check,zone){
  g.save();g.fillStyle=INK;g.textAlign='center';g.textBaseline='middle';
  let fs=17;const set=()=>{g.font='700 '+fs+'px "Zero Moon Body",sans-serif'};set();
  let tw=g.measureText(s).width;
  if(zone){const l=zone[0]+10,r=zone[1]-10,need=tw+(check?28:0);if(r-l<need){fs=Math.max(13,Math.floor(17*(r-l)/need));set();tw=g.measureText(s).width;if(check&&tw+28>r-l)check=false}cx=(l+r)/2}
  const off=check?14:0;g.fillText(s,cx+off,cy+1);
  if(check){g.strokeStyle=INK;g.lineWidth=3;g.lineCap='round';g.lineJoin='round';const x=cx+off-tw/2-26;g.beginPath();g.moveTo(x,cy);g.lineTo(x+6,cy+7);g.lineTo(x+18,cy-7);g.stroke()}
  g.restore()}
 function btnDraw(x,y,w,h,fill,s,o={}){
  g.save();g.globalAlpha=o.alpha===undefined?1:o.alpha;g.translate(x+w/2,y+h/2);if(o.ang)g.rotate(o.ang);if(o.sy!==undefined)g.scale(1,Math.max(.03,Math.abs(o.sy)));
  rr(-w/2,-h/2,w,h,8,fill);if(s)label(s,0,0,o.check,o.clear&&[o.clear[0]-x-w/2,o.clear[1]-x-w/2]);g.restore()}
 const E={H,g,bx:BX,by:BY,bh:BH,orange:ORANGE,green:GREEN,ink:INK,clamp,lerp,ease,rr,path,label,btn:btnDraw};

 function labelText(){return(text.textContent||'Add to cart').trim()}
 function paint(t,still){
  if(!m||!W)return;
  const bw=W-BX-12;g.clearRect(0,0,W,H);
  if(phase==='idle'&&btn.disabled){btnDraw(BX,BY,bw,BH,ORANGE,labelText(),{alpha:.55});return}
  if(still){
   if(phase==='idle'){btnDraw(BX,BY,bw,BH,ORANGE,labelText());return}
   if(!resolved){btnDraw(BX,BY,bw,BH,ORANGE,'Adding…');return}
   t=m.end}
  Object.assign(E,{W,bw,t,peek,imgs,still,ok:phase!=='idle'&&resolved&&t>=m.ok,hover:hover&&!still&&!btn.disabled,rest:hover&&!still&&!btn.disabled});
  m.draw(E)}
 function render(now){
  raf=0;const dt=Math.min(40,now-prev||16);prev=now;
  const still=motion.matches,want=hover&&!still&&phase==='idle'&&!btn.disabled?1:0;
  peek+=(want-peek)*Math.min(1,dt/100);if(Math.abs(want-peek)<.01)peek=want;
  let t=-1;
  if(phase!=='idle'){t=now-t0;if(phase==='run'&&!resolved)t=Math.min(t,m.hold);if(phase==='run'&&resolved&&t>=m.end)settle()}
  paint(t,still);
  if(phase==='run'||peek!==want)raf=requestAnimationFrame(render)}
 function dirty(){if(!raf)raf=requestAnimationFrame(render)}
 function settle(){phase='done';form.removeAttribute('data-zf-hold');form.removeAttribute('data-zf-busy');clearTimeout(timer)}
 function reset(){clearTimeout(timer);phase='idle';resolved=false;form.removeAttribute('data-zf-hold');dirty()}
 function start(){if(!m)return;clearTimeout(timer);phase='run';resolved=false;t0=performance.now();form.setAttribute('data-zf-hold','');dirty()}
 function size(){W=root.clientWidth;const d=Math.min(devicePixelRatio||1,3);cv.width=Math.round(W*d);cv.height=H*d;g.setTransform(d,0,0,d,0,0);dirty()}

 btn.addEventListener('pointerenter',e=>{if(e.pointerType!=='touch'){hover=true;dirty()}});
 btn.addEventListener('pointerleave',()=>{hover=btn.matches(':focus-visible');dirty()});
 btn.addEventListener('focus',()=>{hover=btn.matches(':focus-visible');dirty()});
 btn.addEventListener('blur',()=>{hover=false;dirty()});
 form.addEventListener('zf:cart-start',start);
 form.addEventListener('zf:cart-success',()=>{resolved=true;dirty()});
 form.addEventListener('zf:cart-error',reset);
 form.addEventListener('change',()=>{if(phase==='done')reset();else dirty()});
 document.addEventListener('variant:change',()=>{if(phase==='done')reset();else dirty()});
 new MutationObserver(dirty).observe(text,{childList:true,characterData:true,subtree:true});
 new MutationObserver(dirty).observe(btn,{attributes:true,attributeFilter:['disabled']});
 if(motion.addEventListener)motion.addEventListener('change',dirty);

 const loadImg=src=>new Promise(r=>{const i=new Image();i.onload=()=>r(i);i.onerror=()=>r(null);i.src=src});
 const loadMod=src=>new Promise(r=>{if(reg.mods[id])return r(reg.mods[id]);reg.ready=k=>{if(k===id)r(reg.mods[id])};const s=document.createElement('script');s.src=src;s.onerror=()=>r(null);document.head.append(s)});
 const fonts=document.fonts&&document.fonts.load?Promise.all([document.fonts.load('700 17px "Zero Moon Body"'),document.fonts.load('400 16px "Zero Moon Body"')]).catch(()=>{}):Promise.resolve();
 const boot=()=>Promise.all([loadMod(cfg[id].js),Promise.all(cfg[id].img.map(loadImg)),fonts]).then(([mod,im])=>{
  if(!mod||im.some(i=>!i))return;
  m=mod;imgs=im;new ResizeObserver(size).observe(root);size();cancelAnimationFrame(raf);raf=0;render(performance.now());root.classList.add('is-live')});
 /* Sprites load after the page, so they never compete with the product photo. */
 if(document.readyState==='complete')boot();else addEventListener('load',()=>setTimeout(boot,200),{once:true});
})();
